<template>
    <div class="vue-carprof-finder carprof-finder "
         :class="{'is-homepage': isHomePage, 'map-loaded': doMapLoad, 'map-active': isMobile && showMap, 'list-active': isMobile && !showMap, 'has-video': hasVideo }">
        <div :class="inputFocused ? 'input-is-focused' : ''" class="finder-wrapper">
            <cp-video v-show="hasVideo && !doMapLoad" :has-video="hasVideo" :video="video" :mobile-video="mobileVideo" :is-mobile="isMobile"></cp-video>
            <div class="search-bar-wrapper">
                <div class="row">
                    <div class="search-bar col-12 col-md-6 col-xl-5">
                        <h2 v-if="isHomePage && !doMapLoad" class="text-center">{{ title }}</h2>

                        <div class="inner">
                            <div class="carprof-finder-searchbar finder-search-input">
                                <div class="input-group finder-input" @focusin="handleFocus">
                                    <gmap-autocomplete
                                        slotRefName="gmapAutocomplete"
                                        :select-first-on-enter="true"
                                        class="w-100"
                                        @place_changed="setPlace"
                                        :options="autocompleteOptions"
                                        v-click-outside="() => handleClickOutside()"
                                    >
                                        <input ref="gmapAutocomplete" placeholder="Zoek op plaats of postcode" class="pac-target-input vue-gmap-autocomplete form-control">
                                    </gmap-autocomplete>

                                    <button class="btn-geo-locate" @click="geoLocate">
                                        <span class="visually-hidden">Haal huidige locatie op</span>
                                    </button>

                                    <button
                                        v-if="showResetButton"
                                        @click="handleReset"
                                        class="reset-map"
                                    ><span class="visually-hidden">Reset map</span></button>
                                </div>
                            </div>

                            <div v-if="doMapLoad" :style="{'visibility': (hasActiveMarker ? 'hidden' : 'initial')}">
                                <template v-if="isMobile">
                                    <ul class="mobile-toggle">
                                        <li>
                                            <button :class="{'active': !showMap}" @click="showMap = false">Lijstweergave
                                            </button>
                                        </li>
                                        <li>
                                            <button :class="{'active': showMap}" @click="showMap = true">Kaartweergave
                                            </button>
                                        </li>
                                    </ul>
                                </template>

                                <template v-if="computedMarkers && !loading">
                                    <div class="marker-meta">
                                        <p>{{ markersLength }} vestigingen
                                            <template v-if="hasPlace">bij jou in de buurt</template>
                                        </p>
                                    </div>

                                    <perfect-scrollbar :options="getPsOptions">
                                        <div class="results-wrapper" v-if="showList">
                                            <cp-marker-mini-card
                                                v-for="marker in computedMarkers"
                                                :key="marker.id"
                                                :marker="marker"
                                                :event-bus="eventBus"
                                                :is-home-page="isHomePage"
                                                @marker-clicked="handleMarkerClicked"
                                                @active-marker="handleActiveMarker"
                                            ></cp-marker-mini-card>
                                        </div>
                                    </perfect-scrollbar>
                                </template>
                            </div>

                            <template v-if="loading">
                                <div class="loader"><span class="visually-hidden">aan het laden..</span></div>
                            </template>

                            <transition name="fade">
                                <cp-active-marker
                                    v-if="hasActiveMarker"
                                    :marker="activeMarker"
                                    :event-bus="eventBus"
                                ></cp-active-marker>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="markers && doMapLoad">
                <div class="store-locator" v-show="showMap" aria-hidden="true">
                    <gmap-map
                        :center="center"
                        ref="mapRef"
                        :zoom="mapZoom"
                        map-type-id="roadmap"
                        :options="mapOptions"
                        @zoom_changed="mapZoom = $event"
                        style="width: 100%; height: 100%"
                    >
                        <gmap-cluster :options="clusterOptions">
                            <gmap-marker
                                :key="index"
                                :icon="activeMarker === marker ? activeImageMarker : imageMarker"
                                v-for="(marker, index) in markers"
                                :position="marker.location"
                                :clickable="true"
                                @click="handleMapMarkerClicked(marker)"
                            />
                        </gmap-cluster>
                    </gmap-map>
                </div>
            </template>
        </div>
        <div class="container fast-links-wrapper" v-if="isHomePage && !doMapLoad">
            <div class="row">
                <slot name="fast-links"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import {mixin as focusMixin} from './../../../../../themes/custom/ef2_custom/node_modules/vue-focus';
import {
    SuperClusterAlgorithm
} from './../../../../../themes/custom/ef2_custom/node_modules/@googlemaps/markerclusterer';
import mapSettings from "../constants/map";
import Video from "../../../../../themes/custom/ef2_custom/js/vue/components/Video.vue";
import MarkerMiniCard from "./MarkerMiniCard.vue";
import ActiveMarker from "./ActiveMarker.vue";
import ClickOutside from '../../../../../themes/custom/ef2_custom/node_modules/vue-click-outside';

export default {
    name: "CarprofFinder2",

    mixins: [focusMixin],

    directives: {
        ClickOutside
    },

    components: {
        'cp-video': Video,
        'cp-marker-mini-card': MarkerMiniCard,
        'cp-active-marker': ActiveMarker,
    },

    props: {
        bundle: {
            type: String,
            default: ""
        },
        initialMarkers: {
            type: Array,
        },
        video: {
            type: Object
        },
        mobileVideo: {
            type: Object
        },
        modalBus: {},
    },

    data() {
        return {
            imageMarker: {},
            activeImageMarker: {},
            clusterSvg: window.btoa(`<svg fill="#37444C" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240"> <circle cx="120" cy="120" opacity=".6" r="70" /> <circle cx="120" cy="120" opacity=".3" r="90" /><circle cx="120" cy="120" opacity=".2" r="110" /></svg>`),
            eventBus: new Vue(),
            markers: [],
            doMapLoad: false,
            showMap: true,
            inputFocused: false,
            title: "Zoek uw CarProf",
            geoPlace: {},

            activeMarker: {},

            mapOptions: mapSettings.mapOptions,

            place: null,
            center: mapSettings.center,
            mapZoom: mapSettings.mapZoom,

            autocompleteOptions: {
                types: ['geocode'],
                componentRestrictions: {
                    country: ['nl']
                }
            },

            cameFromMapView: false,
            filteredMarkers: {},
            gmapInputValue: '',
            loading: false,
        }
    },

    async mounted() {
        this.checkDevice();
        this.checkBundleType();

        await this.checkGeoPermissions();
        await this.$gmapApiPromiseLazy();

        this.markers = this.initialMarkers.map((marker) => {
            return {... marker,
                location: new google.maps.LatLng({
                    lat: parseFloat(marker.geolocation.lat),
                    lng: parseFloat(marker.geolocation.lng)
                })
            }
        })

        this.imageMarker = {
            scaledSize: new google.maps.Size(40, 37),
            url: '/themes/custom/ef2_custom/img/marker.svg'
        }

        this.activeImageMarker = {
            scaledSize: new google.maps.Size(65, 60),
            url: '/themes/custom/ef2_custom/img/marker.svg'
        }

        this.eventBus.$on('remove-active-marker', () => this.handleRemoveActiveMarker());
    },

    computed: {
        getPsOptions() {
            if (!this.isMobile) {
                return {}
            }

            return {wheelPropagation: false}
        },

        showList() {
            if (!this.isMobile) {
                return true;
            }

            return !this.showMap;
        },

        device() {
            return this.$mq;
        },

        isMobile() {
            return this.device === 'mobile';
        },

        isHomePage() {
            return _.isEqual(this.bundle, 'homepage');
        },

        clusterOptions() {
            return {
                renderer: {
                    render: ({ count, position }) =>
                        new google.maps.Marker({
                            label: { text: String(count), color: "white", fontSize: "16px", fontWeight: "bold" },
                            icon: {
                                url: `data:image/svg+xml;base64,${this.clusterSvg}`,
                                scaledSize: new google.maps.Size(45, 45),
                            },
                            position,
                            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                        }),
                },
                algorithm: new SuperClusterAlgorithm({radius: 125}),
            };
        },

        hasVideo() {
            return !_.isEmpty(this.video);
        },

        hasPlace() {
            return !lodash.isNil(this.place);
        },

        showResetButton() {
            return (!_.isEmpty(this.gmapInputValue) && !this.loading) || !_.isEmpty(this.geoPlace) && !this.loading;
        },

        hasActiveMarker() {
            return !_.isEmpty(this.activeMarker);
        },

        markersLength() {
            return Object.keys(this.computedMarkers).length;
        },

        showFilteredMarkers() {
            return !_.isEmpty(this.filteredMarkers) && !this.loading;
        },

        computedMarkers() {
            if (this.showFilteredMarkers) {
                return this.filteredMarkers;
            }

            return this.markers;
        },
    },

    methods: {
        handleClickOutside() {
            this.inputFocused = false
        },

        handleRemoveActiveMarker() {
            this.activeMarker = {};
            let zoom = 8;

            if (!_.isEmpty(this.gmapInputValue)) {
                zoom = 11;
            }

            if (this.isMobile && this.cameFromMapView) {
                this.showMap = true;
            }

            this.mapZoom = zoom;
            this.$refs.mapRef.panTo(this.center);
        },

        handleMapMarkerClicked(marker) {
            if (this.activeMarker === marker) {
                return this.handleRemoveActiveMarker();
            }

            this.handleMarkerClicked(marker.geolocation);
            this.handleActiveMarker(marker);
        },

        handleMarkerClicked(payload) {
            this.mapZoom = this.$refs.mapRef.zoom > 11 ? this.$refs.mapRef.zoom : 11;
            this.$refs.mapRef.panTo({lat: parseFloat(payload.lat), lng: parseFloat(payload.lng)})
        },

        handleActiveMarker(payload) {
            if (this.isMobile) {
                this.cameFromMapView = this.showMap;
                this.showMap = false;
            }

            this.activeMarker = payload;
        },

        handleReset() {
            this.filteredMarkers = {};
            this.activeMarker = {};
            this.place = null;
            this.gmapInputValue = '';
            this.$refs.gmapAutocomplete.value = '';
            this.mapZoom = 8;
            this.center = {lat: 52.078663, lng: 4.288788};
            this.geoPlace = {};
            this.$refs.mapRef.panTo(this.center);
        },

        setPlace(place) {
            this.doMapLoad = true

            if (_.isEmpty(place.name)) {
                this.handleReset();
                return;
            }

            this.place = place;
            this.goToPlace();
            this.gmapInputValue = this.$refs.gmapAutocomplete.value;

            this.fetchData(true, false);
            this.activeMarker = {};
        },

        checkBundleType() {
            if (this.isHomePage) {
                this.doMapLoad = false;
                return;
            }

            this.doMapLoad = true;
        },

        goToPlace() {
            if (!this.place || lodash.isNil(this.place.geometry)) {
                return;
            }

            this.center = {
                lat: this.place.geometry.location.lat(),
                lng: this.place.geometry.location.lng(),
            };

            this.mapZoom = 11;
        },

        fetchData(fromPlace = false, fromGeo = false) {
            this.loading = true;
            let url = `/api/garages`;

            if (fromPlace) {
                url = url.concat(`?lat=${this.place.geometry.location.lat()}&lng=${this.place.geometry.location.lng()}`);
            }

            if (fromGeo) {
                url = url.concat(`?lat=${this.geoPlace.lat}&lng=${this.geoPlace.lng}`);
            }

            axios.get(url)
                .then(response => {
                    if (!fromPlace && !fromGeo) {
                        this.markers = response.data;
                        return;
                    }

                    this.filteredMarkers = response.data;
                })
                .catch(error => {
                    this.markers = {};
                    this.filteredMarkers = {};
                })
                .finally(() => {
                    this.loading = false;
                });
        },


        async checkGeoPermissions() {
            navigator.permissions.query({name: 'geolocation'})
                .then(response => {
                    if (!_.isEqual(response.state, 'granted')) {
                        return;
                    }

                    this.geoLocate();
                });
        },

        geoLocate() {
            navigator.geolocation.getCurrentPosition(position => {
                if (_.isEmpty(this.activeMarker)) {
                    const coords = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };

                    this.center = coords;
                    this.geoPlace = coords;

                    this.mapZoom = 11;

                    this.geoCode(coords);
                    this.fetchData(false, true);
                }
            });
        },

        geoCode(coords) {
            const geocoder = new google.maps.Geocoder();

            geocoder.geocode({ location: coords }, (results, status) => {
                if (status !== google.maps.GeocoderStatus.OK) {
                    return;
                }

                const locationString = results[0]?.formatted_address;

                if (_.isNil(locationString)) {
                    return;
                }

                this.gmapInputValue = locationString;
                this.$refs.gmapAutocomplete.value = locationString;
            })
        },

        checkDevice() {
            if (this.device !== 'mobile') {
                return;
            }

            this.showMap = false;
        },

        handleFocus(payload) {
            this.inputFocused = true;
        }
    },
};
</script>